/* eslint-disable @typescript-eslint/no-unused-vars */
import {PassProjectStrategy} from '../pass-project-strategy';
export {CountryCat} from '../pass-project-strategy';
import {AdminRequestsTableDeps} from '../project-strategy.interface';
import {registerStrategy} from '../strategy-registry';
import {ActionState, ConsumeMode, Request, RequestState, RequestStatus, RequestWithDuplicata, SearchPaymentQueryParams} from 'src/app/shared/models/request';
import {Document, User, UserPermission, UserRole} from 'src/app/shared/models/user';
import {UiPermission} from 'src/app/shared/models/permission';
import {ApiService} from '../../services/api.service';
import {CartService, FormApplication} from '../../services/cart.service';
import {RequestService} from '../../services/request.service';
import {PlacesService} from '../../services/places.service';
import {VisaFN, VisaFormConfig, VisaFormName} from 'src/app/shared/models/forms';
import {LangService, TableDataTransformer, createIcon} from 'ngx-satoris';
import {FilterWithType} from 'ngx-satoris/lib/shared/models/filters';
import {PaginationQuery, SortQuery} from 'ngx-satoris/lib/shared/models/params';
import {startOfDay, endOfDay, subMonths} from 'date-fns';
import {DocumentType, DocumentRequestReason, PassportType as ComPassportType} from 'src/app/shared/models/PASS-COM/user-document';
import {applySchemaTransformation} from 'src/app/shared/models/schema-transform';
import {enumToArrayObject} from 'src/app/shared/utils/enumToArrayObject';
import {VISA_FORM_CONFIG} from 'src/app/shared/models/PASS-COM/visa-form';
import {ID_FORM_CONFIG} from 'src/app/shared/models/PASS-COM/id-form';
import {RES_FORM_CONFIG} from 'src/app/shared/models/PASS-COM/res-form';
import {PASS_FORM_CONFIG} from 'src/app/shared/models/PASS-COM/pass-form';
import {ID_FORM_FIRST_CONFIG} from 'src/app/shared/models/PASS-COM/id-form-first';
import {RES_FORM_FIRST_CONFIG} from 'src/app/shared/models/PASS-COM/res-form-first';
import {TableRequestsEnum, TableRequestsFilterEnum, TABLE_REQUESTS_CONFIG} from 'src/app/shared/models/PASS-COM/table-config';
import {DocumentTypeMap} from '../document-type-map';

// Private helpers

function getDefaultPaymentStatusFilter(userRole: UserRole, hasControlPermission: boolean, hasCreatePermission: boolean, hasDefault: boolean): string | null {
  if(!hasDefault) return null;
  if(!userRole) return null;
  if(hasControlPermission) {
    return [RequestState.PAID_NOT_CONFIRMED, RequestState.DELAY_PAY_NOT_CONFIRMED].map(s => s.toString()).join('-');
  }
  if(hasCreatePermission) {
    return RequestState.DELAY_PAY.toString();
  }
  return null;
}

function getDefaultSinceDaysFilter(_userRole: UserRole, _hasControlPermission: boolean): string | null {
  return null;
}

function getDefaultOperationIdFilter(userRole: UserRole | undefined, hasControlPermission: boolean, hasCreatePermission: boolean): string | null {
  if(!userRole) return null;
  if(hasControlPermission || hasCreatePermission) {
    return Object.values(DocumentType).join('-');
  }
  return null;
}

function buildStatusFilterOptions(_isExtension: boolean): {value: string; name: string}[] {
  const allowedStates = [
    RequestState.PAID,
    RequestState.EXPIRED,
    RequestState.PAID_NOT_CONFIRMED,
    RequestState.PENDING,
    RequestState.DELAY_PAY_NOT_CONFIRMED,
    RequestState.DELAY_PAY
  ];
  const baseOptions = enumToArrayObject(RequestStatus, true)
    .filter(item => item.value !== null && allowedStates.includes(Number(item.value)))
    .map(item => ({value: item.value!.toString(), name: item.name}));
  baseOptions.push({
    value: [RequestState.PAID_NOT_CONFIRMED, RequestState.DELAY_PAY_NOT_CONFIRMED].join('-'),
    name: [RequestState.PAID_NOT_CONFIRMED, RequestState.DELAY_PAY_NOT_CONFIRMED].join('-')
  });
  return baseOptions;
}

function buildDocTypeFilterOptions(): {value: string; name: string}[] {
  const allowedDocTypes = Object.values(DocumentType);
  const baseOptions = allowedDocTypes.map(docType => ({value: docType.toString(), name: docType.toString()}));
  baseOptions.push({value: allowedDocTypes.join('-'), name: allowedDocTypes.join('-')});
  return baseOptions;
}

function applyComidValidations(component: any): void {
  // PERSONAL_DETAILS fields
  component.applySchemaValidations('Documents.RequestReason', VisaFormName.PERSONAL_DETAILS, VisaFN.REQUEST_REASON);
  component.applySchemaValidations('RegistrationPortId', VisaFormName.PERSONAL_DETAILS, VisaFN.REGISTRATION_PORT_ID);
  component.applySchemaValidations('IslandOrigin', VisaFormName.PERSONAL_DETAILS, VisaFN.ISLAND_ORIGIN);
  component.applySchemaValidations('LastName', VisaFormName.PERSONAL_DETAILS, VisaFN.LAST_NAME);
  component.applySchemaValidations('FirstName', VisaFormName.PERSONAL_DETAILS, VisaFN.FIRST_NAME);
  component.applySchemaValidations('MaidenName', VisaFormName.PERSONAL_DETAILS, VisaFN.MAIDEN_NAME);
  component.applySchemaValidations('Gender', VisaFormName.PERSONAL_DETAILS, VisaFN.GENDER);
  component.applySchemaValidations('MaritalStatus', VisaFormName.PERSONAL_DETAILS, VisaFN.MARITAL_STATUS);
  component.applySchemaValidations('BirthDay', VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_DAY);
  component.applySchemaValidations('BirthDay', VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_DAY);
  component.applySchemaValidations('BirthCity', VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_CITY);
  component.applySchemaValidations('BirthCountry', VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_COUNTRY);
  component.applySchemaValidations('Height', VisaFormName.PERSONAL_DETAILS, VisaFN.HEIGHT);
  component.applySchemaValidations('HairColor', VisaFormName.PERSONAL_DETAILS, VisaFN.HAIR_COLOR);
  component.applySchemaValidations('EyeColor', VisaFormName.PERSONAL_DETAILS, VisaFN.EYE_COLOR);
  component.applySchemaValidations('Occupation', VisaFormName.PERSONAL_DETAILS, VisaFN.OCCUPATION);
  component.applySchemaValidations('MothersName', VisaFormName.PERSONAL_DETAILS, VisaFN.MOTHERS_NAME);
  component.applySchemaValidations('FathersName', VisaFormName.PERSONAL_DETAILS, VisaFN.FATHERS_NAME);
  component.applySchemaValidations('NNI', VisaFormName.PERSONAL_DETAILS, VisaFN.NNI);
  // CONTACT_DETAILS fields
  component.applySchemaValidations('AddressLine1', VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_1);
  component.applySchemaValidations('AddressLine2', VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_2);
  component.applySchemaValidations('AddressLine3', VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_3);
  component.applySchemaValidations('Phone', VisaFormName.CONTACT_DETAILS, VisaFN.PHONE);
  component.applySchemaValidations('IndicatifTelephoneNumber', VisaFormName.CONTACT_DETAILS, VisaFN.INDICATIVE_PHONE);
  // MISCELLANEOUS_DETAILS fields
  component.applySchemaValidations('PassportType', VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.PASSPORT_TYPE);
  // DOCUMENT fields
  component.applySchemaValidations('Documents.ResidencePermit', VisaFormName.DOCUMENT, VisaFN.RESIDENCE_PERMIT);
  component.applySchemaValidations('Documents.BirthCertificate', VisaFormName.DOCUMENT, VisaFN.BIRTH_CERTIFICATE);
  component.applySchemaValidations('Documents.ResidenceCertificate', VisaFormName.DOCUMENT, VisaFN.RESIDENCE_CERTIFICATE);
  component.applySchemaValidations('Documents.NationalityCertificate', VisaFormName.DOCUMENT, VisaFN.NATIONALITY_CERTIFICATE);
  component.applySchemaValidations('Documents.IdCardScan', VisaFormName.DOCUMENT, VisaFN.ID_CARD_SCAN);
  component.applySchemaValidations('Documents.LossDeclaration', VisaFormName.DOCUMENT, VisaFN.LOSS_DECLARATION);
  component.applySchemaValidations('Documents.IdentityPhoto', VisaFormName.DOCUMENT, VisaFN.IDENTITY_PHOTO);
  component.applySchemaValidations('Documents.FormDemand', VisaFormName.DOCUMENT, VisaFN.FORM_DEMAND);
}

function applyComresValidations(component: any): void {
  // PERSONAL_DETAILS fields
  component.applySchemaValidations('Documents.RequestReason', VisaFormName.PERSONAL_DETAILS, VisaFN.REQUEST_REASON);
  component.applySchemaValidations('Nationality', VisaFormName.PERSONAL_DETAILS, VisaFN.NATIONALITY);
  component.applySchemaValidations('RegistrationPortId', VisaFormName.PERSONAL_DETAILS, VisaFN.REGISTRATION_PORT_ID);
  component.applySchemaValidations('LastName', VisaFormName.PERSONAL_DETAILS, VisaFN.LAST_NAME);
  component.applySchemaValidations('FirstName', VisaFormName.PERSONAL_DETAILS, VisaFN.FIRST_NAME);
  component.applySchemaValidations('MaidenName', VisaFormName.PERSONAL_DETAILS, VisaFN.MAIDEN_NAME);
  component.applySchemaValidations('Gender', VisaFormName.PERSONAL_DETAILS, VisaFN.GENDER);
  component.applySchemaValidations('MaritalStatus', VisaFormName.PERSONAL_DETAILS, VisaFN.MARITAL_STATUS);
  component.applySchemaValidations('BirthDay', VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_DAY);
  component.applySchemaValidations('BirthDay', VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_DAY);
  component.applySchemaValidations('BirthCity', VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_CITY);
  component.applySchemaValidations('BirthCountry', VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_COUNTRY);
  component.applySchemaValidations('Height', VisaFormName.PERSONAL_DETAILS, VisaFN.HEIGHT);
  component.applySchemaValidations('HairColor', VisaFormName.PERSONAL_DETAILS, VisaFN.HAIR_COLOR);
  component.applySchemaValidations('EyeColor', VisaFormName.PERSONAL_DETAILS, VisaFN.EYE_COLOR);
  component.applySchemaValidations('Occupation', VisaFormName.PERSONAL_DETAILS, VisaFN.OCCUPATION);
  component.applySchemaValidations('MothersName', VisaFormName.PERSONAL_DETAILS, VisaFN.MOTHERS_NAME);
  component.applySchemaValidations('FathersName', VisaFormName.PERSONAL_DETAILS, VisaFN.FATHERS_NAME);
  component.applySchemaValidations('NNI', VisaFormName.PERSONAL_DETAILS, VisaFN.NNI);
  component.applySchemaValidations('CSIdentifier', VisaFormName.PERSONAL_DETAILS, VisaFN.CS_IDENTIFIER);
  // CONTACT_DETAILS fields
  component.applySchemaValidations('AddressLine1', VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_1);
  component.applySchemaValidations('AddressLine2', VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_2);
  component.applySchemaValidations('AddressLine3', VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_3);
  component.applySchemaValidations('Phone', VisaFormName.CONTACT_DETAILS, VisaFN.PHONE);
  component.applySchemaValidations('IndicatifTelephoneNumber', VisaFormName.CONTACT_DETAILS, VisaFN.INDICATIVE_PHONE);
  // MISCELLANEOUS_DETAILS fields
  component.applySchemaValidations('PassportType', VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.PASSPORT_TYPE);
  // DOCUMENT fields
  component.applySchemaValidations('Documents.IdCardScan', VisaFormName.DOCUMENT, VisaFN.ID_CARD_SCAN);
  component.applySchemaValidations('Documents.Photo', VisaFormName.DOCUMENT, VisaFN.PHOTO);
  component.applySchemaValidations('Documents.EmployerCommitmentForm', VisaFormName.DOCUMENT, VisaFN.EMPLOYER_COMMITMENT_FORM);
  component.applySchemaValidations('Documents.WorkContract', VisaFormName.DOCUMENT, VisaFN.WORK_CONTRACT);
  component.applySchemaValidations('Documents.ResidenceCertificate', VisaFormName.DOCUMENT, VisaFN.RESIDENCE_CERTIFICATE);
  component.applySchemaValidations('Documents.PassportScan', VisaFormName.DOCUMENT, VisaFN.PASSPORT_SCAN);
  component.applySchemaValidations('Documents.LossDeclaration', VisaFormName.DOCUMENT, VisaFN.LOSS_DECLARATION);
  component.applySchemaValidations('Documents.IdentityPhoto', VisaFormName.DOCUMENT, VisaFN.IDENTITY_PHOTO);
}

export function applyCompassValidations(component: any): void {
  // PERSONAL_DETAILS fields
  component.applySchemaValidations('Documents.RequestReason', VisaFormName.PERSONAL_DETAILS, VisaFN.REQUEST_REASON);
  component.applySchemaValidations('RegistrationPortId', VisaFormName.PERSONAL_DETAILS, VisaFN.REGISTRATION_PORT_ID);
  component.applySchemaValidations('IslandOrigin', VisaFormName.PERSONAL_DETAILS, VisaFN.ISLAND_ORIGIN);
  component.applySchemaValidations('LastName', VisaFormName.PERSONAL_DETAILS, VisaFN.LAST_NAME);
  component.applySchemaValidations('FirstName', VisaFormName.PERSONAL_DETAILS, VisaFN.FIRST_NAME);
  component.applySchemaValidations('MaidenName', VisaFormName.PERSONAL_DETAILS, VisaFN.MAIDEN_NAME);
  component.applySchemaValidations('Gender', VisaFormName.PERSONAL_DETAILS, VisaFN.GENDER);
  component.applySchemaValidations('MaritalStatus', VisaFormName.PERSONAL_DETAILS, VisaFN.MARITAL_STATUS);
  component.applySchemaValidations('BirthDay', VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_DAY);
  component.applySchemaValidations('BirthCity', VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_CITY);
  component.applySchemaValidations('BirthCountry', VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_COUNTRY);
  component.applySchemaValidations('Height', VisaFormName.PERSONAL_DETAILS, VisaFN.HEIGHT);
  component.applySchemaValidations('HairColor', VisaFormName.PERSONAL_DETAILS, VisaFN.HAIR_COLOR);
  component.applySchemaValidations('EyeColor', VisaFormName.PERSONAL_DETAILS, VisaFN.EYE_COLOR);
  component.applySchemaValidations('Occupation', VisaFormName.PERSONAL_DETAILS, VisaFN.OCCUPATION);
  component.applySchemaValidations('MothersName', VisaFormName.PERSONAL_DETAILS, VisaFN.MOTHERS_NAME);
  component.applySchemaValidations('FathersName', VisaFormName.PERSONAL_DETAILS, VisaFN.FATHERS_NAME);
  // CONTACT_DETAILS fields
  component.applySchemaValidations('AddressLine1', VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_1);
  component.applySchemaValidations('AddressLine2', VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_2);
  component.applySchemaValidations('AddressLine3', VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_3);
  component.applySchemaValidations('Phone', VisaFormName.CONTACT_DETAILS, VisaFN.PHONE);
  component.applySchemaValidations('IndicatifTelephoneNumber', VisaFormName.CONTACT_DETAILS, VisaFN.INDICATIVE_PHONE);
  // MISCELLANEOUS_DETAILS fields
  component.applySchemaValidations('Documents.PassportType', VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.PASSPORT_TYPE);
  component.applySchemaValidations('PreviousPassportNumber', VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.PREVIOUS_PASSPORT_NUMBER);
  component.applySchemaValidations('NNI', VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.NNI);
  // DOCUMENT fields
  component.applySchemaValidations('Documents.ApplicationForm', VisaFormName.DOCUMENT, VisaFN.APPLICATION_FORM);
  component.applySchemaValidations('Documents.IdCardScan', VisaFormName.DOCUMENT, VisaFN.ID_CARD_SCAN);
  component.applySchemaValidations('Documents.PassportScan', VisaFormName.DOCUMENT, VisaFN.PASSPORT_SCAN);
  component.applySchemaValidations('Documents.LossDeclaration', VisaFormName.DOCUMENT, VisaFN.LOSS_DECLARATION);
  component.applySchemaValidations('Documents.AuthorizationForm', VisaFormName.DOCUMENT, VisaFN.AUTHORIZATION_FORM);
  component.applySchemaValidations('Documents.IdentificationSheet', VisaFormName.DOCUMENT, VisaFN.IDENTIFICATION_SHEET);
  component.applySchemaValidations('Documents.ApprovedMissionOrder', VisaFormName.DOCUMENT, VisaFN.APPROVED_MISSION_ORDER);
  component.applySchemaValidations('Documents.IdentityPhoto', VisaFormName.DOCUMENT, VisaFN.IDENTITY_PHOTO);
  component.applySchemaValidations('Documents.FormDemand', VisaFormName.DOCUMENT, VisaFN.FORM_DEMAND);
}

// --- Strategy class ---

class PassComStrategy extends PassProjectStrategy {
  readonly referenceSchema = 'comres';
  readonly documentTypeMap: DocumentTypeMap = {
    passport: DocumentType.COMPASS,
    identityCard: DocumentType.COMID,
    residenceCard: DocumentType.COMRES
  };
  readonly tableRequestsConfig = TABLE_REQUESTS_CONFIG;

  constructor() {
    super();
    this.initDocumentTypeMap();
  }

  canTrackTimeslot(_req: RequestWithDuplicata): boolean {
    return false;
  }

  enrollmentNoticeKey(req: RequestWithDuplicata): string | null {
    if(req.timeslot) return 'afterAndUntil';
    if(this.canTrackTimeslot(req)) return 'timeslot.toBook';
    return null;                            
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getStatusTheme(request: any, requestService: any): any {
    const isBlacklist = requestService.isBlacklisted(request);
    switch(request.state) {
    case 2:
      return {severity: 2, color: '#8FF88D', iconColor: '#03B000', icon: 'right-from-bracket', state: requestService.lang.transform('payment_status.DYN.2')};
    case 0:
      return {severity: 3, color: '#C9C9C9', iconColor: '#747474', icon: 'hourglass-start', state: requestService.lang.transform('payment_status.DYN.0')};
    case 3:
      return {severity: 2, color: '#FFA14A', iconColor: '#A85100', icon: 'copy', state: requestService.lang.transform('payment_status.DYN.3')};
    case 4:
      return {severity: 2, color: '#FF823C', iconColor: '#9D3900', icon: 'undo', state: requestService.lang.transform('payment_status.DYN.4')};
    case 9:
      return {severity: 2, color: '#C9F88D', iconColor: '#6ABD00', icon: requestService.lang.transform('payment_status.DYN.' + request.document.id + '.icon'), actionState: ActionState.READY_CHECK, state: requestService.lang.transform('payment_status.DYN.9')};
    case 5:
      return {severity: 3, color: '#F88D8D', iconColor: '#B50000', icon: isBlacklist ? 'ban' : 'xmark-circle', actionState: ActionState.REFUSED, state: requestService.lang.transform('payment_status.DYN.5' + (isBlacklist ? '.blacklisted' : ''))};
    case 7:
      return {severity: 4, color: '#FFE455', iconColor: '#B39600', icon: 'clock', state: requestService.lang.transform('payment_status.DYN.7')};
    case 1:
      return {severity: 2, color: '#8FF88D', iconColor: '#03B000', icon: 'clock', state: requestService.lang.transform('payment_status.DYN.1')};
    case 6:
      return {severity: 3, color: '#FF823C', iconColor: '#9D3900', icon: 'clock', state: requestService.lang.transform('payment_status.DYN.6')};
    case 8:
      return {severity: 3, color: '#FF823C', iconColor: '#9D3900', icon: 'clock', state: requestService.lang.transform('payment_status.DYN.8')};
    default:
      return {severity: 2, color: '#C9C9C9', iconColor: '#747474', icon: 'question', state: request.state + '.state', descState: request.state + '.desc'};
    }
  }

  // --- Business rules ---

  showWarning(req: Request, request: RequestService, cart: CartService): boolean {
    const daysFromMillis = request.usageUntilFromNowDays(req);
    return (this.isCanHaveOnArrival({countryCat: this.setCurrentCountryCat({indexed: {Nationality: req.nationality || req.metadata?.nationality}})})) &&
      !cart.currentApplication?.isExtend && daysFromMillis > 0;
  }

  evaluateCanBeAcceptedRefused(current: RequestWithDuplicata): boolean {
    return current?.actualManualConfirmRounds === 1;
  }

  evaluateCanBeReviewed(current: RequestWithDuplicata, user: User): boolean {
    const autoConfirm = current.document?.autoConfirm;
    if(!autoConfirm) return false;
    // eslint-disable-next-line no-eval
    return (!eval(autoConfirm)(current, null, user) && current.actualManualConfirmRounds > 1);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hasUiPerm(this: any, label: UiPermission): boolean {
    const seniority1 = this.api.checkSeniority() === 1;
    const seniority2 = this.api.checkSeniority() === 2;
    const seniority3 = this.api.checkSeniority() === 3;
    const seniority4 = this.api.checkSeniority() === 4;
    const isAllowControl = this.api.hasPerm(UserPermission.ALLOW_CONTROL);
    const isAllowConsume = this.api.hasPerm(UserPermission.ALLOW_CONSUME);
    const isAllowAdmin = this.api.hasPerm(UserPermission.ALLOW_ADMIN);
    const isAllowExtension = this.api.hasPerm(UserPermission.ALLOW_EXTENSION);

    // Shared base permissions
    const basePermissions: Partial<Record<UiPermission, boolean>> = {
      [UiPermission.SHOW_REFUSE_ACCEPT_BTN]: false,
      [UiPermission.CAN_UPDATE_FIELDS]: false,
      [UiPermission.CAN_UPDATE_FIELD_AS_BORDER]: false,
      [UiPermission.SHOW_CLOSE_APP_BTN]: false,
      [UiPermission.IS_NUMBER_APPLICATION_VISIBLE]: true,
      [UiPermission.IS_STATUS_PAID_FOR_PRINT]: true,
      [UiPermission.EVALUATE_CAN_BEREVIEWED_ADMIN]: false,
      [UiPermission.CAN_UPDATE_DOC]: true,
      [UiPermission.SHOW_ENTRY_REGISTER_BTN]: seniority1 || seniority2 || seniority4,
      [UiPermission.CAN_LOAD_INBOUND]: seniority1 || seniority2 || seniority3 || seniority4 || isAllowConsume || isAllowAdmin,
      [UiPermission.CAN_LOAD_FULLMETADATA]: seniority1 || seniority2 || seniority3 || seniority4 || isAllowAdmin || isAllowControl || isAllowExtension,
      [UiPermission.SHOW_PRINT_APPROVAL_LETTER]: true,
      [UiPermission.SHOW_HQ_REFERENCE_BTN]: true,
      [UiPermission.SHOW_SET_TIMESLOT_BTN]: false
    };

    // Role-specific overrides/additions
    const conditionsWorker: Partial<Record<UiPermission, boolean>> = {
      ...basePermissions,
      [UiPermission.SHOW_PAYMENT_BTN]: seniority2,
      [UiPermission.SHOW_QR_SCANNER_BTN]: seniority1 || seniority2 || seniority3 || seniority4
    };

    const conditionsAdmin: Partial<Record<UiPermission, boolean>> = {
      ...basePermissions,
      [UiPermission.ALLOW_DUPLICATE_PAYMENT]: seniority4,
      [UiPermission.CAN_UPDATE_NNI]: seniority4
    };

    const hasPermWorker = this.api.env.useGuichet && this.api.userRole.isWorker && (conditionsWorker[label] ?? false);
    const hasPermAdmin = this.api.env.useGuichet && seniority4 && (conditionsAdmin[label] ?? false);

    return hasPermWorker || hasPermAdmin;
  }

  // --- Form configs ---

  loadFormConfigs(): {[id: string]: VisaFormConfig} {
    return {
      originalVisaFormConfig: {...VISA_FORM_CONFIG},
      originalIdFormConfig: {...ID_FORM_CONFIG},
      originalResFormConfig: {...RES_FORM_CONFIG},
      originalPassFormConfig: {...PASS_FORM_CONFIG},
      originalIdFirstFormConfig: {...ID_FORM_FIRST_CONFIG},
      originalResFirstFormConfig: {...RES_FORM_FIRST_CONFIG}
    };
  }

  getFormConfig(docType: DocumentType, currentRequest: Request, api?: ApiService): string | undefined {
    const selectedReason = currentRequest?.selectedRequestReason;
    const visaTypeId = docType || currentRequest?.visaType?.id;
    const isCustomer = !!api?.userRole?.isCustomer;
    if(!isCustomer && visaTypeId === DocumentType.COMID && selectedReason === 'FIRST_REQUEST') {
      return 'originalIdFirstFormConfig';
    }
    if(!isCustomer && visaTypeId === DocumentType.COMRES && selectedReason === 'FIRST_REQUEST') {
      return 'originalResFirstFormConfig';
    }
    switch(visaTypeId) {
    case DocumentType.COMID:
      return 'originalIdFormConfig';
    case this.documentTypeMap.residenceCard:
      return 'originalResFormConfig';
    case this.documentTypeMap.passport:
      return 'originalPassFormConfig';
    default:
      return 'originalVisaFormConfig';
    }
  }

  getVisaTypes(all: Document[], apiService: ApiService, _cart: CartService, _place: PlacesService, _consumeMode: ConsumeMode): [boolean, Document[]] {
    return [false, all.filter(d => apiService.userRole.isCustomer ? d.customer : true)];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getRequestData(self: RequestService, request: Request, _application: FormApplication): any {
    const schema = request.visaType ? request.visaType.schema : undefined;
    switch(request.visaType?.id) {
    case this.documentTypeMap.passport: {
      return {
        RegistrationPortId: applySchemaTransformation('RegistrationPortId', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.REGISTRATION_PORT_ID, request.formConfig), schema) || undefined,
        LastName: applySchemaTransformation('LastName', self.normalizeName(self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.LAST_NAME, request.formConfig)), schema) || undefined,
        FirstName: applySchemaTransformation('FirstName', self.normalizeName(self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.FIRST_NAME, request.formConfig)), schema) || undefined,
        BirthDay: applySchemaTransformation('BirthDay', ((birthDayValue) => birthDayValue !== undefined && birthDayValue !== null && birthDayValue !== '' ? new Date(birthDayValue).getTime() : undefined)(self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_DAY, request.formConfig)), schema) || undefined,
        PreviousPassportNumber: applySchemaTransformation('PreviousPassportNumber', self.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.PREVIOUS_PASSPORT_NUMBER, request.formConfig), schema) || undefined,
        NNI: applySchemaTransformation('NNI', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.NNI, request.formConfig), schema) || applySchemaTransformation('NNI', self.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.NNI, request.formConfig), schema) || undefined,
        Documents: {
          PassportType: applySchemaTransformation('Documents.PassportType', self.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.PASSPORT_TYPE, request.formConfig), schema) || undefined,
          RequestReason: applySchemaTransformation('Documents.RequestReason', request.selectedRequestReason, schema) || undefined,
          ApplicationForm: applySchemaTransformation('Documents.ApplicationForm', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.APPLICATION_FORM, request.formConfig), schema) || undefined,
          IdCardScan: applySchemaTransformation('Documents.IdCardScan', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.ID_CARD_SCAN, request.formConfig), schema) || undefined,
          PassportScan: applySchemaTransformation('Documents.PassportScan', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.PASSPORT_SCAN, request.formConfig), schema) || undefined,
          AuthorizationForm: applySchemaTransformation('Documents.AuthorizationForm', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.AUTHORIZATION_FORM, request.formConfig), schema) || undefined,
          ApprovedMissionOrder: applySchemaTransformation('Documents.ApprovedMissionOrder', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.APPROVED_MISSION_ORDER, request.formConfig), schema) || undefined,
          IdentificationSheet: applySchemaTransformation('Documents.IdentificationSheet', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.IDENTIFICATION_SHEET, request.formConfig), schema) || undefined,
          LossDeclaration: applySchemaTransformation('Documents.LossDeclaration', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.LOSS_DECLARATION, request.formConfig), schema) || undefined,
          IdentityPhoto: applySchemaTransformation('Documents.IdentityPhoto', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.IDENTITY_PHOTO, request.formConfig), schema) || undefined,
          FormDemand: applySchemaTransformation('Documents.FormDemand', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.FORM_DEMAND, request.formConfig), schema) || undefined
        }
      };
    }
    case this.documentTypeMap.identityCard: {
      const phoneLocal = applySchemaTransformation('phoneLocal', self.getFieldValue(VisaFormName.CONTACT_DETAILS, VisaFN.PHONE_LOCAL, request.formConfig), schema) || undefined;
      const indicatif = applySchemaTransformation('IndicatifTelephoneNumber', self.getFieldValue(VisaFormName.CONTACT_DETAILS, VisaFN.INDICATIVE_PHONE, request.formConfig), schema) || undefined;
      const normalizedPhoneLocal = phoneLocal ? String(phoneLocal).replace(/^0+/, '') : '';
      const phoneFull = (indicatif && normalizedPhoneLocal) ? `${indicatif}-${normalizedPhoneLocal}` : undefined;
      return {
        Nationality: applySchemaTransformation('Nationality', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.NATIONALITY, request.formConfig), schema) || undefined,
        RegistrationPortId: applySchemaTransformation('RegistrationPortId', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.REGISTRATION_PORT_ID, request.formConfig), schema) || undefined,
        IslandOrigin: applySchemaTransformation('IslandOrigin', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.ISLAND_ORIGIN, request.formConfig), schema) || undefined,
        LastName: applySchemaTransformation('LastName', self.normalizeName(self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.LAST_NAME, request.formConfig)), schema) || undefined,
        FirstName: applySchemaTransformation('FirstName', self.normalizeName(self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.FIRST_NAME, request.formConfig)), schema) || undefined,
        MaidenName: applySchemaTransformation('MaidenName', self.normalizeName(self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.MAIDEN_NAME, request.formConfig)), schema) || undefined,
        AddressLine1: applySchemaTransformation('AddressLine1', self.getFieldValue(VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_1, request.formConfig), schema) || undefined,
        AddressLine2: applySchemaTransformation('AddressLine2', self.getFieldValue(VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_2, request.formConfig), schema) || undefined,
        AddressLine3: applySchemaTransformation('AddressLine3', self.getFieldValue(VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_3, request.formConfig), schema) || undefined,
        Phone: phoneFull || undefined,
        HairColor: applySchemaTransformation('HairColor', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.HAIR_COLOR, request.formConfig)?.toUpperCase(), schema) || undefined,
        EyeColor: applySchemaTransformation('EyeColor', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.EYE_COLOR, request.formConfig)?.toUpperCase(), schema) || undefined,
        BirthDay: applySchemaTransformation('BirthDay', ((birthDayValue) => birthDayValue !== undefined && birthDayValue !== null && birthDayValue !== '' ? new Date(birthDayValue).getTime() : undefined)(self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_DAY, request.formConfig)), schema) || undefined,
        BirthCity: applySchemaTransformation('BirthCity', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_CITY, request.formConfig), schema) || undefined,
        BirthCountry: applySchemaTransformation('BirthCountry', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_COUNTRY, request.formConfig), schema) || undefined,
        MothersName: applySchemaTransformation('MothersName', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.MOTHERS_NAME, request.formConfig), schema) || undefined,
        FathersName: applySchemaTransformation('FathersName', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.FATHERS_NAME, request.formConfig), schema) || undefined,
        Occupation: applySchemaTransformation('Occupation', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.OCCUPATION, request.formConfig), schema) || undefined,
        Gender: applySchemaTransformation('Gender', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.GENDER, request.formConfig)?.toUpperCase(), schema) || undefined,
        MaritalStatus: applySchemaTransformation('MaritalStatus', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.MARITAL_STATUS, request.formConfig), schema) || undefined,
        Height: applySchemaTransformation('Height', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.HEIGHT, request.formConfig), schema) || undefined,
        PassportType: applySchemaTransformation('Documents.PassportType', self.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.PASSPORT_TYPE, request.formConfig), schema) || undefined,
        PreviousPassportNumber: applySchemaTransformation('Documes.PreviousPassportNumber', self.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.PREVIOUS_PASSPORT_NUMBER, request.formConfig), schema) || undefined,
        NNI: applySchemaTransformation('NNI', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.NNI, request.formConfig), schema)
          || applySchemaTransformation('NNI', self.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.NNI, request.formConfig), schema)
          || undefined,
        Documents: {
          RequestReason: applySchemaTransformation('Documents.RequestReason', request.selectedRequestReason, schema) || undefined,
          Photo: applySchemaTransformation('Documents.Photo', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.PHOTO, request.formConfig), schema) || undefined,
          ApplicationForm: applySchemaTransformation('Documents.ApplicationForm', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.APPLICATION_FORM, request.formConfig), schema) || undefined,
          BirthCertificate: applySchemaTransformation('Documents.BirthCertificate', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.BIRTH_CERTIFICATE, request.formConfig), schema) || undefined,
          ResidenceCertificate: applySchemaTransformation('Documents.ResidenceCertificate', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.RESIDENCE_CERTIFICATE, request.formConfig), schema) || undefined,
          NationalityCertificate: applySchemaTransformation('Documents.NationalityCertificate', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.NATIONALITY_CERTIFICATE, request.formConfig), schema) || undefined,
          ParentalAuthorization: applySchemaTransformation('Documents.ParentalAuthorization', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.PARENTAL_AUTHORIZATION, request.formConfig), schema) || undefined,
          IdCardScan: applySchemaTransformation('Documents.IdCardScan', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.ID_CARD_SCAN, request.formConfig), schema) || undefined,
          PassportScan: applySchemaTransformation('Documents.PassportScan', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.PASSPORT_SCAN, request.formConfig), schema) || undefined,
          AuthorizationForm: applySchemaTransformation('Documents.AuthorizationForm', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.AUTHORIZATION_FORM, request.formConfig), schema) || undefined,
          LossDeclaration: applySchemaTransformation('Documents.LossDeclaration', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.LOSS_DECLARATION, request.formConfig), schema) || undefined,
          ResidencePermit: applySchemaTransformation('Documents.ResidencePermit', self.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.RESIDENCE_PERMIT, request.formConfig), schema) || undefined,
          EmployerCommitmentForm: applySchemaTransformation('Documents.EmployerCommitmentForm', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.EMPLOYER_COMMITMENT_FORM, request.formConfig), schema) || undefined,
          WorkContract: applySchemaTransformation('Documents.WorkContract', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.WORK_CONTRACT, request.formConfig), schema) || undefined,
          IdentityPhoto: applySchemaTransformation('Documents.IdentityPhoto', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.IDENTITY_PHOTO, request.formConfig), schema) || undefined,
          FormDemand: applySchemaTransformation('Documents.FormDemand', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.FORM_DEMAND, request.formConfig), schema) || undefined
        }
      };
    }
    case this.documentTypeMap.residenceCard: {
      const phoneLocal = applySchemaTransformation('phoneLocal', self.getFieldValue(VisaFormName.CONTACT_DETAILS, VisaFN.PHONE_LOCAL, request.formConfig), schema) || undefined;
      const indicatif = applySchemaTransformation('IndicatifTelephoneNumber', self.getFieldValue(VisaFormName.CONTACT_DETAILS, VisaFN.INDICATIVE_PHONE, request.formConfig), schema) || undefined;
      const normalizedPhoneLocal = phoneLocal ? String(phoneLocal).replace(/^0+/, '') : '';
      const phoneFull = (indicatif && normalizedPhoneLocal) ? `${indicatif}-${normalizedPhoneLocal}` : undefined;
      return {
        Nationality: applySchemaTransformation('Nationality', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.NATIONALITY, request.formConfig), schema) || undefined,
        RegistrationPortId: applySchemaTransformation('RegistrationPortId', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.REGISTRATION_PORT_ID, request.formConfig), schema) || undefined,
        LastName: applySchemaTransformation('LastName', self.normalizeName(self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.LAST_NAME, request.formConfig)), schema) || undefined,
        FirstName: applySchemaTransformation('FirstName', self.normalizeName(self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.FIRST_NAME, request.formConfig)), schema) || undefined,
        MaidenName: applySchemaTransformation('MaidenName', self.normalizeName(self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.MAIDEN_NAME, request.formConfig)), schema) || undefined,
        AddressLine1: applySchemaTransformation('AddressLine1', self.getFieldValue(VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_1, request.formConfig), schema) || undefined,
        AddressLine2: applySchemaTransformation('AddressLine2', self.getFieldValue(VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_2, request.formConfig), schema) || undefined,
        AddressLine3: applySchemaTransformation('AddressLine3', self.getFieldValue(VisaFormName.CONTACT_DETAILS, VisaFN.ADDRESS_LINE_3, request.formConfig), schema) || undefined,
        Phone: phoneFull || undefined,
        HairColor: applySchemaTransformation('HairColor', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.HAIR_COLOR, request.formConfig)?.toUpperCase(), schema) || undefined,
        EyeColor: applySchemaTransformation('EyeColor', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.EYE_COLOR, request.formConfig)?.toUpperCase(), schema) || undefined,
        BirthDay: applySchemaTransformation('BirthDay', ((birthDayValue) => birthDayValue !== undefined && birthDayValue !== null && birthDayValue !== '' ? new Date(birthDayValue).getTime() : undefined)(self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_DAY, request.formConfig)), schema) || undefined,
        BirthCity: applySchemaTransformation('BirthCity', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_CITY, request.formConfig), schema) || undefined,
        BirthCountry: applySchemaTransformation('BirthCountry', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.BIRTH_COUNTRY, request.formConfig), schema) || undefined,
        MothersName: applySchemaTransformation('MothersName', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.MOTHERS_NAME, request.formConfig), schema) || undefined,
        FathersName: applySchemaTransformation('FathersName', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.FATHERS_NAME, request.formConfig), schema) || undefined,
        Occupation: applySchemaTransformation('Occupation', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.OCCUPATION, request.formConfig), schema) || undefined,
        Gender: applySchemaTransformation('Gender', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.GENDER, request.formConfig)?.toUpperCase(), schema) || undefined,
        MaritalStatus: applySchemaTransformation('MaritalStatus', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.MARITAL_STATUS, request.formConfig), schema) || undefined,
        Height: applySchemaTransformation('Height', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.HEIGHT, request.formConfig), schema) || undefined,
        PassportType: applySchemaTransformation('PassportType', self.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.PASSPORT_TYPE, request.formConfig), schema) || undefined,
        PreviousPassportNumber: applySchemaTransformation('PreviousPassportNumber', self.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.PREVIOUS_PASSPORT_NUMBER, request.formConfig), schema) || undefined,
        NNI: applySchemaTransformation('NNI', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.NNI, request.formConfig), schema)
          || applySchemaTransformation('NNI', self.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.NNI, request.formConfig), schema)
          || undefined,
        CSIdentifier: applySchemaTransformation('CSIdentifier', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.CS_IDENTIFIER, request.formConfig), schema) || undefined,
        Documents: {
          RequestReason: applySchemaTransformation('Documents.RequestReason', self.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.REQUEST_REASON, request.formConfig), schema) || undefined,
          ApplicationForm: applySchemaTransformation('Documents.ApplicationForm', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.APPLICATION_FORM, request.formConfig), schema) || undefined,
          BirthCertificate: applySchemaTransformation('Documents.BirthCertificate', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.BIRTH_CERTIFICATE, request.formConfig), schema) || undefined,
          ResidenceCertificate: applySchemaTransformation('Documents.ResidenceCertificate', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.RESIDENCE_CERTIFICATE, request.formConfig), schema) || undefined,
          NationalityCertificate: applySchemaTransformation('Documents.NationalityCertificate', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.NATIONALITY_CERTIFICATE, request.formConfig), schema) || undefined,
          ParentalAuthorization: applySchemaTransformation('Documents.ParentalAuthorization', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.PARENTAL_AUTHORIZATION, request.formConfig), schema) || undefined,
          PassportScan: applySchemaTransformation('Documents.PassportScan', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.PASSPORT_SCAN, request.formConfig), schema) || undefined,
          AuthorizationForm: applySchemaTransformation('Documents.AuthorizationForm', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.AUTHORIZATION_FORM, request.formConfig), schema) || undefined,
          LossDeclaration: applySchemaTransformation('Documents.LossDeclaration', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.LOSS_DECLARATION, request.formConfig), schema) || undefined,
          ResidencePermit: applySchemaTransformation('Documents.ResidencePermit', self.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.RESIDENCE_PERMIT, request.formConfig), schema) || undefined,
          EmployerCommitmentForm: applySchemaTransformation('Documents.EmployerCommitmentForm', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.EMPLOYER_COMMITMENT_FORM, request.formConfig), schema) || undefined,
          WorkContract: applySchemaTransformation('Documents.WorkContract', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.WORK_CONTRACT, request.formConfig), schema) || undefined,
          IdentityPhoto: applySchemaTransformation('Documents.IdentityPhoto', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.IDENTITY_PHOTO, request.formConfig), schema) || undefined,
          FormDemand: applySchemaTransformation('Documents.FormDemand', self.getFieldValue(VisaFormName.DOCUMENT, VisaFN.FORM_DEMAND, request.formConfig), schema) || undefined
        }
      };
    }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  applySchemaValidations(component: any, documentType?: DocumentType): void {
    if(!documentType) {
      documentType = component.cart?.currentRequest?.visaType?.id;
    }
    switch(documentType) {
    case this.documentTypeMap.identityCard:
      applyComidValidations(component);
      break;
    case this.documentTypeMap.residenceCard:
      applyComresValidations(component);
      break;
    case this.documentTypeMap.passport:
      applyCompassValidations(component);
      break;
    default:
      console.warn(`No schema validations found for document type: ${documentType}`);
    }
  }

  // --- Admin table ---

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  buildAdminRequestsTableTransformer(deps: AdminRequestsTableDeps): TableDataTransformer<any> {
    const stateFilterOption = buildStatusFilterOptions(false)
      .map((f: any) => ({...f, name: !f.value ? (deps.lang as LangService).transform('global.noFilter') : (deps.lang as LangService).transform('payment_status.DYN.' + f.value)}));
    const documentTypeOptions: {value: string; name: string}[] = buildDocTypeFilterOptions().map(opt => ({value: opt.value, name: (deps.lang as LangService).transform(opt.value)}));
    const requestSinceOption = [
      {name: 'global.noFilter', value: null},
      {name: (deps.lang as LangService).transform('time.day', {value: 1}), value: '1d'},
      {name: (deps.lang as LangService).transform('time.days', {value: 3}), value: '3d'},
      {name: (deps.lang as LangService).transform('time.week', {value: 1}), value: '1w'},
      {name: (deps.lang as LangService).transform('time.weeks', {value: 2}), value: '2w'},
      {name: (deps.lang as LangService).transform('time.month', {value: 1}), value: '1m'},
      {name: (deps.lang as LangService).transform('time.months', {value: 2}), value: '2m'},
      {name: (deps.lang as LangService).transform('time.months', {value: 6}), value: '6m'},
      {name: (deps.lang as LangService).transform('time.year', {value: 1}), value: '1y'}
    ];

    return {
      columnConfigs: {
        [TableRequestsEnum.LOCK]: {
          headerContent: {value: '', prefix: [createIcon('book-open-reader', {style: {alignItems: 'center'}, tooltip: 'tooltip.tableLockTitle'})]}
        }
      },
      filterConfigs: {
        [TableRequestsFilterEnum.NATIONALITY]: {
          selectOptions: deps.request.getNationalities(true).filter(option => !!option?.value && option.value !== '-')
        },
        [TableRequestsFilterEnum.OPERATION_ID]: {
          initialFilterValue: getDefaultOperationIdFilter(deps.api.userRole, deps.api.hasPerm(deps.api.perm.ALLOW_CONTROL), deps.api.hasPerm(deps.api.perm.ALLOW_CREATE)) ?? undefined,
          selectOptions: documentTypeOptions
        },
        [TableRequestsFilterEnum.PAYMENT_STATUS]: {
          initialFilterValue: getDefaultPaymentStatusFilter(deps.api.userRole, deps.api.hasPerm(deps.api.perm.ALLOW_CONTROL), deps.api.hasPerm(deps.api.perm.ALLOW_CREATE), false) ?? undefined,
          selectOptions: stateFilterOption
        },
        [TableRequestsFilterEnum.SINCE_DAYS]: {
          initialFilterValue: getDefaultSinceDaysFilter(deps.api.userRole, deps.api.hasPerm(deps.api.perm.ALLOW_CONTROL)) ?? undefined,
          selectOptions: requestSinceOption
        },
        [TableRequestsFilterEnum.PASSPORT_TYPE]: {
          selectOptions: Object.values(ComPassportType).map(p => ({value: p, name: (deps.lang as LangService).transform('DYN.' + p)}))
        },
        [TableRequestsFilterEnum.REQUEST_REASON]: {
          selectOptions: Object.values(DocumentRequestReason).map(r => ({value: r, name: (deps.lang as LangService).transform('DYN.' + r)}))
        }
      },
      transformData: (requestData: any) => ({
        [TableRequestsEnum.EXPANDABLE_DATA]: {value: `<div>ID: ${requestData.id}</div>`},
        [TableRequestsEnum.LOCK]: deps.createLockContent(requestData),
        [TableRequestsEnum.NATIONALITY]: {value: requestData.nationality && requestData.nationality !== '-' ? 'DYN.' + requestData.nationality : ''},
        [TableRequestsEnum.BATCH_ID]: {value: requestData.batchId || ''},
        [TableRequestsEnum.FIRST_NAME]: {value: requestData.firstName || ''},
        [TableRequestsEnum.LAST_NAME]: {value: requestData.lastName || ''},
        [TableRequestsEnum.FULLNAME]: {value: requestData.completeName || ''},
        [TableRequestsEnum.DOCUMENT_TYPE]: {value: requestData.documentType || ''},
        [TableRequestsEnum.PAYMENT_STATUS]: deps.createPaymentStatusContent(requestData),
        [TableRequestsEnum.CREATION_DATE]: {value: requestData.creationDate || ''},
        [TableRequestsEnum.PRICE]: {value: requestData.currency + requestData.price || ''},
        [TableRequestsEnum.USAGE_AFTER]: {value: requestData.usageAfter || '', className: !deps.request.isUsageDateValid(requestData.usageAfter, 'usageAfter') ? 'expiring-date' : ''},
        [TableRequestsEnum.USAGE_UNTIL]: {value: requestData.usageUntil || '', className: !deps.request.isUsageDateValid(requestData.usageUntil, 'usageUntil') ? 'expiring-date' : ''},
        [TableRequestsEnum.TIMESLOT]: {value: requestData.timeslot || ''},
        [TableRequestsEnum.APPLICATION_ID]: {value: requestData.id || ''},
        [TableRequestsEnum.REGISTRATION_PORT_ID]: {value: requestData.registrationPortId || ''},
        [TableRequestsEnum.REQUEST_REASON]: {value: requestData.meta?.requestReason ? 'DYN.' + requestData.meta.requestReason : ''},
        [TableRequestsEnum.PASSPORT_TYPE]: {value: requestData.meta?.passportType ? 'DYN.' + requestData.meta.passportType : ''}
      })
    };
  }

  // --- Search ---

  buildSearchParamsForPayments(input: {filters: FilterWithType[]; sort: SortQuery}): {query: SearchPaymentQueryParams; sortColumn: 'id' | 'createdAt' | 'isUrgent' | 'timeslot' | undefined; sortOrder: 'ASC' | 'DESC' | null} {
    const {filters, sort} = input;
    const sortColumn: 'id' | 'createdAt' | 'isUrgent' | 'timeslot' = (sort?.column?.value as any);
    let sortOrder: 'ASC' | 'DESC' | null = null;
    if(sort?.order && sort?.column?.value) {
      sortOrder = (String(sort.order).toUpperCase() === 'DESC') ? 'DESC' : 'ASC';
    }
    if(String(sort?.order).toLowerCase() === 'none') {
      sortOrder = null;
    }
    const queryParams: SearchPaymentQueryParams = {operationIds: []};
    filters?.forEach(filter => {
      if((filter as any).serverFilter && (filter as any).value) {
        switch((filter as any).filterId) {
        case TableRequestsFilterEnum.PAYMENT_STATUS: {
          const val = (filter as any).value;
          (queryParams as any).state = val ? val.toString().split('-').map((v: string) => v) : [];
          break;
        }
        case TableRequestsFilterEnum.FIRST_NAME:
          (queryParams as any).firstName = (filter as any).value.toString();
          break;
        case TableRequestsFilterEnum.BATCH_ID:
          (queryParams as any).batchId = (filter as any).value.toString();
          break;
        case TableRequestsFilterEnum.OPERATION_ID: {
          const val = (filter as any).value;
          (queryParams as any).operationIds = val ? val.toString().split('-').map((v: string) => v) : [];
          break;
        }
        case TableRequestsFilterEnum.APPLICATION_ID:
          (queryParams as any).id = (filter as any).value.toString();
          break;
        case TableRequestsFilterEnum.CREATE_AT_START:
          (queryParams as any).createAtStart = startOfDay(new Date((filter as any).value.toString()));
          break;
        case TableRequestsFilterEnum.CREATE_AT_END:
          (queryParams as any).createAtEnd = endOfDay(new Date((filter as any).value.toString()));
          break;
        case TableRequestsFilterEnum.TIMESLOT_START:
          (queryParams as any).timeslotStart = startOfDay(new Date((filter as any).value.toString()));
          break;
        case TableRequestsFilterEnum.TIMESLOT_END:
          (queryParams as any).timeslotEnd = endOfDay(new Date((filter as any).value.toString()));
          break;
        case TableRequestsFilterEnum.REQUEST_REASON: {
          (queryParams as any).requestReason = (filter as any).value;
          break;
        }
        case TableRequestsFilterEnum.PASSPORT_TYPE: {
          (queryParams as any).passportType = (filter as any).value;
          break;
        }
        }
      }
    });
    return {query: queryParams, sortColumn, sortOrder};
  }

  searchApplications(api: ApiService, pagination: PaginationQuery, filters: FilterWithType[], sort: SortQuery): Promise<unknown> {
    const built = this.buildSearchParamsForPayments({filters, sort});
    if(!filters || filters.length === 0) {
      (built.query).createAtStart = startOfDay(subMonths(new Date(), 2));
    }
    if(api.userRole?.isWorker) {
      (built.query).registrationPortId = api.userPlaceId;
    }
    return api.searchPayment(built.query, built.sortColumn, built.sortOrder ?? undefined, pagination.offset, pagination.limit);
  }
}

// Extra getters — project-specific (not in the standard 22)
export function getDocumentTypeIsFirstIdentityCard(): DocumentType {
  return DocumentType.COMID;
}
export function getDocumentTypeIsFirstResidenceCard(): DocumentType {
  return DocumentType.COMRES;
}

// Auto-register
const passComStrategy = new PassComStrategy();
registerStrategy(passComStrategy);
export {passComStrategy};
